import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AuthService } from '@core/auth';
import { PROFILES, RolesEnum } from '@shared/models';

@Directive({
    selector: '[accessControl]',
    standalone: false,
})
export class AccessControlDirective implements OnInit {

    @Input() accessControl: RolesEnum | RolesEnum[] | string | string[] | any;

    constructor(
        private elementRef: ElementRef,
        private authService: AuthService
    ) { }

    ngOnInit(): void {
        !this.checkAccess(this.accessControl) && this.elementRef.nativeElement.style.setProperty('display', 'none', 'important');
    }

    checkAccess(role: RolesEnum | RolesEnum[]): boolean {
        if (!role) 
            return true;

        if (Array.isArray(role)) {
            const userRoles = this.authService.user ? this.authService.user.roles : [];
            return role.some((access) => userRoles.includes(access));
        }

        return (PROFILES as any)[role] ? this.authService.user.roles.some((profile: string) => (PROFILES as any)[profile] && (PROFILES as any)[profile].includes(role)) : false;
    }

}
